module.exports = __webpack_public_path__ + "static/img/tu2@3x.68393e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tu2@3x.png
// module id = j4t2
// module chunks = 2